import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import LogoutConfirmModal from './logout-confirm-modal.vue';

const MOUNT_ID = 'residency-lk-logout-modal-vue';
const LOGOUT_URL_DATASET_KEY = 'logoutUrl';

let logoutConfirmModalApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

function findMountElement(root?: ParentNode): HTMLElement | null {
  if (root) {
    return root.querySelector<HTMLElement>(`#${MOUNT_ID}`);
  }
  return document.getElementById(MOUNT_ID);
}

function getLogoutUrl(mountEl: HTMLElement): string {
  return mountEl.dataset[LOGOUT_URL_DATASET_KEY] ?? '';
}

export function initLogoutConfirmModal(root?: ParentNode): void {
  const mountEl = findMountElement(root);
  if (!mountEl) return;

  destroyLogoutConfirmModal();

  mountEl.innerHTML = '';

  const app = createApp(LogoutConfirmModal, {
    logoutUrl: getLogoutUrl(mountEl),
  });
  logoutConfirmModalApp = app;
  app.use(AntDesignVue).mount(mountEl);
  currentMountEl = mountEl;
}

export function destroyLogoutConfirmModal(): void {
  if (!logoutConfirmModalApp || !currentMountEl) return;

  logoutConfirmModalApp.unmount();
  currentMountEl.innerHTML = '';
  logoutConfirmModalApp = null;
  currentMountEl = null;
}
